import clsx from "clsx";

interface Props {
  group: string;
  className?: string;
}

const VARIANT: Record<string, string> = {
  SuperAdmin: "np-chip--super",
  Admin: "np-chip--admin",
  Worker: "np-chip--worker",
};

export function RoleChip({ group, className }: Props) {
  const v = VARIANT[group] ?? "np-chip--admin";
  return (
    <span className={clsx("np-chip", v, className)} title={`Group: ${group}`}>
      <span className="np-chip-dot" aria-hidden />
      {group}
    </span>
  );
}
